import { Box, styled } from "@mui/material";

const PageContent = styled(Box)({
  flex: 1,
  overflow: "auto",
});
export default PageContent;
